<template>
  <div>
    <div>
      <Titulo :titulo="'Informes - ' + routeName" />
    </div>
    <!-- coger el parametro que se envio por la ruta -->
    <!-- {{$route.params.id}} -->
    <div class="margin-informes">
      <p class="mb-4 text-justify">
        Ingresar número de la novedad o rango de fechas de los casos que desea
        consultar.
      </p>

      <!--
        @props
            data: Array,            required: true
            pagination: boolean,    required: false
            perPage: Number,        required: false
            SetectFiltro: Array     required: false
            filtro: boolean         required: false
      -->
      <table-component
        pagination
        filtro
        @click-buscar="buscar"
        @click-event="clickEvent"
        :data="data"
        :dataLength="dataLength"
        :showFilterDates="true"
        :showFilterCaseNumber="true"
        :showFilterCaseName="false"
        :showExportToExcel="true"
        :perPage="perPage"
      >
        <table-column
          slot="label"
          :label="'Caso'"
          v-bind:value="'caso'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Nombre'"
          v-bind:value="'nombre'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Tipo'"
          v-bind:value="'tipo'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Fecha Registro'"
          v-bind:value="'fecha_registro'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Estado'"
          v-bind:value="'estado'"
          :customClass="'text-center'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Acciones'"
          :customClass="'text-center'"
        >
          <table-column
            slot="icon"
            :icon="'fa fa-search-plus'"
            :class="'btn btn-sm btn-info'"
            :slug="'AmpliarInformacion'"
            :tooltip="'Ampliar información'"
          ></table-column>
        </table-column>
      </table-component>
      <b-modal id="modal-1" title="Detalle del caso" hide-footer size="xl">
        <div class="m-5" v-if="this.detalle.caso">
          <h3 class="color-secundary">Información del caso</h3>
          <div class>
            <div class="container">
              <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-6" v-if="detalle.caso">
                  <b>Numero:</b>
                  {{ detalle.caso }}
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6" v-if="detalle.nombre">
                  <b>Nombre:</b>
                  {{ detalle.nombre }}
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6" v-if="detalle.tipo">
                  <b>Tipo:</b>
                  {{ detalle.tipo }}
                </div>
                <div
                  class="col-sm-12 col-md-6 col-lg-6"
                  v-if="detalle.fecha_registro"
                >
                  <b>Fecha de registro:</b>
                  {{ detalle.fecha_registro }}
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6" v-if="detalle.estado">
                  <b>Estado:</b>
                  {{ detalle.estado }}
                </div>
                <div
                  class="col-sm-12 col-md-12 col-lg-12"
                  v-if="detalle.resolucion"
                >
                  <b>Resolución:</b>
                  {{ detalle.resolucion }}
                </div>
                <div
                  class="col-sm-12 col-md-12 col-lg-12"
                  v-if="detalle.descripcion"
                >
                  <b>Descripcion:</b>
                  {{ detalle.descripcion }}
                </div>
              </div>
              <br />
              <br />
              <label
                class="btn btn-primary"
                v-if="
                  detalle.estado == 'PENDIENTE DE INFORMACIÓN NOVEDADES' ||
                    detalle.estado == 'PENDIENTE DE INFORMACIÓN OTROS'
                "
              >
                <i class="fa fa-file"></i>
                <input
                  v-on:change="cargarDocumento(detalle.caso)"
                  id="archivo"
                  ref="archivo"
                  name="archivo"
                  type="file"
                  multiple="multiple"
                  style="display: none;"
                />
                Subir documento
              </label>
              &nbsp;
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import SelectNovedad from "@/data/SelectQueEsNovedad.json";
import SelectTipoNovedad from "@/data/SelectTipoNovedad.json";
import XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  name: "SubirInformes",
  data() {
    return {
      SelectNovedad: SelectNovedad,
      SelectTipoNovedad: SelectTipoNovedad,
      selectQueEsNovedad: "",
      selectTipoNovedad: "",
      perPage: 10,
      fecha_inicio: this.$moment()
        .startOf("month")
        .format("YYYY-MM-DD 00:00:00"),
      fecha_fin: this.$moment().format("YYYY-MM-DD 23:59:59"),
      detalle: {},
    };
  },
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    TableComponent: () => import("@/components/table/TableComponent"),
    TableColumn: () => import("@/components/table/TableColumn"),
  },
  computed: {
    ...mapGetters({
      TablaVerProducto: "pages/TablaVerProducto",
      SelectFiltroTabla: "pages/SelectFiltroTabla",
      loading: "loading",
    }),
    data() {
      return this.$store.getters["pages/dataInformes"].datos;
    },
    dataLength() {
      try {
        return this.$store.getters["pages/dataInformes"].paginacion.total;
      } catch (err) {
        return 0;
      }
    },
    routeName() {
      return this.$router.currentRoute.name;
    },
  },
  methods: {
    buscar(event) {
      this.fecha_inicio = event.fecha_inicio;
      this.fecha_fin = event.fecha_fin;
      this.nombre = event.nombre;
      this.case_number = event.case_number;
      this.loadData();
    },
    async clickEvent(data, slug) {
      switch (slug) {
        case "paginacion":
          this.loadData(data.nRows, data.page);
          break;
        case "AmpliarInformacion":
          this.$store.commit("SET_LOADING", true);
          try {
            let response = await this.$store.state.api.get("informes/novedad", {
              params: { paginar: false, case_number: data.caso, detalle: true },
            });

            this.detalle = response.data.datos;
          } catch (err) {
            this.$toasted.show(
              "Lo sentimos, ocurrió un error al intentar consultar el detalle del caso",
              {
                theme: "toasted-primary",
                position: "top-right",
                duration: 10000,
              }
            );
          }

          this.$store.commit("SET_LOADING", false);
          this.$root.$emit("bv::show::modal", "modal-1", "#btnShow");

          break;
        case "export-to-excel":
          this.$toasted.show("Por favor espere mientras exportamos los datos", {
            theme: "toasted-primary",
            position: "top-center",
            duration: 10000,
          });
          this.$store.commit("SET_LOADING", true);
          try {
            let response = await this.$store.state.api.get("informes/novedad", {
              params: { paginar: false },
            });
            let data = XLSX.utils.json_to_sheet(response.data.datos, {
              header: [
                "caso",
                "nombre",
                "tipo",
                "fecha_registro",
                "estado",
                "resolucion",
                "descripcion",
              ],
            });

            data["A1"].v = "N° caso";
            data["B1"].v = "Nombre";
            data["C1"].v = "Tipo";
            data["D1"].v = "Fecha registro";
            data["E1"].v = "Estado";
            data["F1"].v = "Resolución";
            data["G1"].v = "Descripción";

            var workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, data, "Casos");
            var wopts = { bookType: "xlsx", bookSST: false, type: "array" };
            var wbout = XLSX.write(workbook, wopts);
            saveAs(
              new Blob([wbout], { type: "application/octet-stream" }),
              "Casos.xlsx"
            );

            this.$toasted.show("El archivo fue exportado exitosamente", {
              theme: "toasted-primary",
              position: "top-right",
              duration: 10000,
            });
          } catch (err) {
            this.$toasted.show(
              "Ocurrió un error al intentar exportar el archivo",
              {
                theme: "toasted-primary",
                position: "top-right",
                duration: 10000,
              }
            );
          }
          this.$store.commit("SET_LOADING", false);
          break;
        default:
          break;
      }
    },
    async cargarDocumento(caso) {
      this.$root.$emit("bv::hide::modal", "modal-1", "#btnShow");

      this.$toasted.show("Estamos procesando su solicitud", {
        theme: "toasted-primary",
        position: "top-right",
        duration: 5000,
      });

      this.$store.commit("SET_LOADING", true);
      let formData = new FormData();
      let count = this.$refs.archivo.files.length;

      for (var x = 0; x < count; x++) {
        formData.append("archivos[]", this.$refs.archivo.files[x]);
      }
      formData.set("caso", caso);

      try {
        this.response = await this.$store.state.api.post(
          "informes/novedad/documento",
          formData
        );
      } catch (err) {
        this.$toasted.show(
          "Lo sentimos, ocurrió un error al cargar los archivos",
          {
            theme: "toasted-primary",
            position: "top-right",
            duration: 10000,
          }
        );
      }

      this.$store.commit("SET_LOADING", false);

      if (this.response.data.mensaje) {
        this.$toasted.show(this.response.data.mensaje, {
          theme: "toasted-primary",
          position: "top-right",
          duration: 5000,
        });
      }

      if (this.response.data.documentos) {
        this.$toasted.show(
          "Los siguientes archivos no se almacenaron correctamente " +
            this.response.data.mensaje +
            ".Por favor envíe el documento al correo operaciones@fga.com.co con numero de referencia " +
            caso,
          {
            theme: "toasted-primary",
            position: "top-right",
            duration: 5000,
          }
        );
      }

      if (this.response.data.updates) {
        this.$toasted.show(
          "No ha sido posible actualizar el estado del caso " +
            this.response.data.updates,
          {
            theme: "toasted-primary",
            position: "top-right",
            duration: 5000,
          }
        );
      }

      this.loadData(this.perPage, 1);
    },
    loadData(row, page, paginar = true) {
      this.$store.dispatch("pages/fetch", {
        endpoint: "informes/novedad",
        params: {
          row: row,
          page: page ? page : 1,
          paginar: paginar,
          fecha_inicio: this.fecha_inicio,
          fecha_fin: this.fecha_fin,
          account_id: true,
          case_number: this.case_number,
          nombre: this.nombre,
        },
      });
    },
  },
  mounted() {
    this.loadData(this.perPage, 1);
  },
};
</script>
